import {Capacitor} from '@capacitor/core';

export const BILLING_CHANNEL = Object.freeze({
  PLAY_READ_ONLY: 'play-read-only',
  IOS_READ_ONLY: 'ios-read-only',
  STRIPE: 'stripe'
});

export function getBillingChannel(platform = Capacitor.getPlatform()) {
  if (platform === 'web') return BILLING_CHANNEL.STRIPE;
  if (platform === 'android') return BILLING_CHANNEL.PLAY_READ_ONLY;
  return BILLING_CHANNEL.IOS_READ_ONLY;
}

export function allowsStripeBilling(platform = Capacitor.getPlatform()) {
  return getBillingChannel(platform) === BILLING_CHANNEL.STRIPE;
}

export function isIosConsumptionOnly(platform = Capacitor.getPlatform()) {
  return getBillingChannel(platform) === BILLING_CHANNEL.IOS_READ_ONLY;
}
